import { cn } from '@virginexperiencedays/tailwind';

import { Nugget } from '../../../navigation/Nugget';
import { DisplayHeading } from '../../../typography/DisplayHeading';

type MoreFromCategoryProps = {
  className?: string;
  dataTestId?: string;
  title?: string;
  categories: string[];
  homeLink: string;
  slugNameMap?: Record<string, string>;
};
export const MoreFromCategory = ({
  className,
  categories,
  homeLink,
  slugNameMap,
  dataTestId = 'more-from-category',
  title = 'More from: ',
}: MoreFromCategoryProps) => {
  const getSlugName = (slug: string) => slugNameMap?.[slug] ?? slug.replace(/-/gi, ' ');
  const categoryObjects = categories.map((category, index) => {
    const name = getSlugName(category);
    return {
      id: index,
      name,
      href: `${homeLink}/${category}`,
    };
  });

  return (
    <div
      className={cn('md:flex md:items-baseline md:justify-center', className)}
      data-testid={dataTestId}
    >
      <DisplayHeading
        className="text-neutral-strong m-0 mb-4 whitespace-nowrap text-base capitalize md:mb-0 md:mr-4"
        size="4"
        as="h2"
        data-testid="more-from-category-title"
      >
        {title}
      </DisplayHeading>
      <ul className="me-0 ms-0 flex list-none flex-wrap gap-x-2 gap-y-4 ps-0 md:justify-center">
        {categoryObjects.map(({ id, name, href }) => (
          <li className="rounded" key={`more-from-category-link-${id}`}>
            <Nugget
              className="block break-all rounded px-4 py-1 capitalize"
              href={href}
              asLink
              isHrefExternal
              testId="more-from-category-link"
            >
              {name}
            </Nugget>
          </li>
        ))}
      </ul>
    </div>
  );
};
